import type { GetAdminV1StoresStoreIdDiscountsIdCodesParams } from '@nucleus-commerce/api-client/admin';

import type { DiscountListParams } from '../api/discounts-api';

/** Store-scoped keys: switching stores never shares cache. */
export const discountKeys = {
  all: (storeId: string) => ['stores', storeId, 'discounts'] as const,
  lists: (storeId: string) => [...discountKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: DiscountListParams) =>
    [...discountKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...discountKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...discountKeys.details(storeId), id] as const,
  allCodes: (storeId: string, id: string) =>
    [...discountKeys.detail(storeId, id), 'codes'] as const,
  codes: (storeId: string, id: string, params: GetAdminV1StoresStoreIdDiscountsIdCodesParams) =>
    [...discountKeys.allCodes(storeId, id), params] as const,
  usages: (storeId: string, id: string, cursor: string | undefined) =>
    [...discountKeys.detail(storeId, id), 'usages', cursor ?? null] as const,
};
